
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect, useState } from "react";

interface SavedAddress {
  id: string;
  label: string | null;
  street: string;
}

interface SavedAddressSelectProps {
  savedAddresses: SavedAddress[];
  onSelect: (addressId: string) => void;
  prefix: string;
  currentAddress?: {
    street: string;
    street2: string;
    city: string;
    province: string;
    postalCode: string;
    country: string;
  };
}

export const SavedAddressSelect = ({ 
  savedAddresses, 
  onSelect, 
  prefix,
  currentAddress 
}: SavedAddressSelectProps) => {
  const [selectedValue, setSelectedValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    // If we have a current address with a street, try to match it with saved addresses
    if (currentAddress?.street && savedAddresses.length > 0) {
      // Find if any saved address matches the current address
      const match = savedAddresses.find(
        (addr) => addr.street === currentAddress.street
      );
      
      if (match) {
        setSelectedValue(match.id);
      }
    }
  }, [currentAddress, savedAddresses]);
  
  const handleSelect = (value: string) => {
    setSelectedValue(value);
    onSelect(value);
  };

  if (savedAddresses.length === 0) return null;

  return (
    <div className="w-full md:w-64">
      <Select onValueChange={handleSelect} value={selectedValue}>
        <SelectTrigger id={`${prefix}-saved-addresses`} className="w-full">
          <SelectValue placeholder="Select Saved Address" />
        </SelectTrigger>
        <SelectContent>
          {savedAddresses.map((address) => (
            <SelectItem key={address.id} value={address.id}>
              {address.label || address.street}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
